export const LOCAL_STORAGE_AUTH_TOKENS = 'authTokens';
export const LOCAL_STORAGE_REMEMBER_PATH_TO_RETURN = 'rememberPathnameToReturnAfterLogin';
export const LOCAL_STORAGE_VIDEO_STATE = 'videoState';
